import { render } from "./AppHeader.vue?vue&type=template&id=a961ab84"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=a961ab84&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__